import React, { createContext, useState, ReactNode } from 'react';

type LocaleContextType = {
  locale: string | undefined;
  setLocale: (locale: string | undefined) => void;
};

export const LocaleContext = createContext<LocaleContextType | undefined>(undefined);

export const LocaleContextProvider = ({ children }: { children: ReactNode }) => {
  const [locale, setLocale] = useState<string | undefined>(undefined);

  return (
    <LocaleContext.Provider value={{ locale, setLocale }}>
      {children}
    </LocaleContext.Provider>
  );
};
